const fullcontJump = require("../../../../../components/fullcont/fullcont-jump");

export function jumperToSale(detail) {
  const line = detail.ev?.target?.closest(".line");
  const otherFieldElement = line?.querySelector(".sale_id .otherField");
  const rawOtherField = otherFieldElement?.getAttribute("otherField");

  if (!rawOtherField) return;

  let otherField;

  try {
    otherField = JSON.parse(rawOtherField);
  } catch (error) {
    return;
  }

  const saleCode = String(otherField.sale_code || "").trim();
  if (saleCode === "") return;

  fullcontJump.start({
    actJump: "goToSales",
    dtId: "sale-dt",
    toSearch: saleCode,
  });
}

export function jumperToPurchase(detail) {
  const line = detail.ev?.target?.closest(".line");
  const otherFieldElement = line?.querySelector(".purchase_id .otherField");
  const rawOtherField = otherFieldElement?.getAttribute("otherField");

  if (!rawOtherField) return;

  let otherField;

  try {
    otherField = JSON.parse(rawOtherField);
  } catch (error) {
    return;
  }

  const purchaseCode = String(otherField.purchase_code || "").trim();
  if (purchaseCode === "") return;

  fullcontJump.start({
    actJump: "goToPurchase",
    dtId: "purchase-dt",
    toSearch: purchaseCode,
  });
}

export function jumperToCustomer(detail) {
  const line = detail.ev?.target?.closest(".line");
  const otherFieldElement = line?.querySelector(".customer_id .otherField");
  const rawOtherField = otherFieldElement?.getAttribute("otherField");

  if (!rawOtherField) return;

  let otherField;

  try {
    otherField = JSON.parse(rawOtherField);
  } catch (error) {
    return;
  }

  const customerCode = String(otherField.customer_code || "").trim();
  if (customerCode === "") return;

  fullcontJump.start({
    actJump: "goToCustomer",
    dtId: "customer-dt",
    toSearch: customerCode,
  });
}

export function jumperToProvider(detail) {
  const line = detail.ev?.target?.closest(".line");
  const otherFieldElement = line?.querySelector(".provider_id .otherField");
  const rawOtherField = otherFieldElement?.getAttribute("otherField");

  if (!rawOtherField) return;

  let otherField;

  try {
    otherField = JSON.parse(rawOtherField);
  } catch (error) {
    return;
  }

  const providerCode = String(otherField.provider_code || "").trim();
  if (providerCode === "") return;

  fullcontJump.start({
    actJump: "goToProvider",
    dtId: "provider-dt",
    toSearch: providerCode,
  });
}

export function jumperToItem(detail) {
  const line = detail.ev?.target?.closest(".line");
  const otherFieldElement = line?.querySelector(".item_id .otherField");
  const rawOtherField = otherFieldElement?.getAttribute("otherField");

  if (!rawOtherField) return;

  let otherField;

  try {
    otherField = JSON.parse(rawOtherField);
  } catch (error) {
    return;
  }

  const itemCode = String(otherField.item_code || "").trim();
  if (itemCode === "") return;

  fullcontJump.start({
    actJump: "goToItem",
    dtId: "item-dt",
    toSearch: itemCode,
  });
}
